import React from "react";
import "./styles.scss";

const CardRotate = ({
  cancelText,
  submitText,
  onCancel,
  onSubmit,
  background,
  style,
  backStyle,
  className,
  active,
}) => {
  return (
    <div className="row">
      <div className="col-md-4 col-sm-6 col-xs-12">
        <div className="cardRotate">
          <div
            className={`cover ${className} ${active && "active"}`}
            style={style}
          >
            <img src={background} alt="news img" />
            <div className="cardRotate-back" style={backStyle}>
              <button className="submit-btn" onClick={onSubmit}>
                <span>{submitText}</span>
              </button>
              <button className="abandon-btn" onClick={onCancel}>
                <span>{cancelText}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { CardRotate };
